const ACKO_CASH_BURN_KEY = "cashburn";

const normalizeDiscountComponentKey = (key: string) =>
  key.replace(/[^a-z0-9]/gi, "").toLowerCase();

export const getAckoCashBurnAmount = (
  discountComponents: Record<string, unknown> = {}
) => {
  const matchingEntry = Object.entries(discountComponents).find(
    ([key]) => normalizeDiscountComponentKey(key) === ACKO_CASH_BURN_KEY
  );
  const amount = Number(matchingEntry?.[1]);

  return Number.isFinite(amount) ? amount : 0;
};

export const getAckoDriveSavingsAmount = (priceData: {
  acko_drive_savings?: unknown;
  discount_components?: Record<string, unknown>;
}) => {
  const savings = Number(priceData.acko_drive_savings);

  return (
    (Number.isFinite(savings) ? savings : 0) +
    getAckoCashBurnAmount(priceData.discount_components)
  );
};
